import React, { useEffect } from 'react'
import Login from './pages/Login'
import Layout from './pages/Layout'
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Home2 from './pages/Home2'
import Event from './pages/Event';
import Preview from './pages/Preview';
import ModalComponent from './components/ModalComponent';
import CreateEvent from './components/CreateEvent';

import { useParams, useNavigate, useRouteMatch,useLocation  } from "react-router-dom";
import { getSaveUsers } from "./utilities/common"


export default function App() {

  let navigate = useNavigate();

  let urlParam = JSON.parse(localStorage?.getItem('urlParam'))
  console.log(urlParam)
  const location = useLocation();

  useEffect(() => {
    let data = getSaveUsers()
    console.log(data)

    console.log(location.pathname.split('/'))
    console.log("localhost..........")

    if (data === null) {
      if(location.pathname.split('/')[1]==="preview"){
        navigate(location.pathname)
      }
      else if (urlParam?.length > 1) {
        navigate(`/event/${urlParam[5]}/${urlParam[6]}`);
      } else {
        navigate("/")
      }
    }
  }, [])

  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="home" element={<Home2 />} />
        <Route path="event/:id/:name" element={<Event></Event>}></Route>
        <Route path="preview/:id/:name" element={<Preview />} />
        <Route path="modal" element={<CreateEvent />} />

      </Routes>
    </div>
  )
}
